import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, } from '@angular/core';
import {ObjectsProvider} from '@providers/objects/objects.provider';
import {Subscription} from 'rxjs';
import {ComplianceCalculateService} from '../../services/wizard-form-groups-services/compliance-calculate.service';
import {WizardEnums, WizardInterfaces} from '../../wizard.namespace';
import {WizardFormEventsService} from '../../services/wizard-form-groups-services/wizard-form-events.service';
import {WizardControlService} from '../../services/wizard-control.service';
import {map, takeUntil} from 'rxjs/operators';
import {WizardSpecialist} from '../../models/wizard-specialist';
import {ModelsInterfaces} from '@namespaces/models.namespace';

@Component({
    selector: 'compliance-table',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './compliance-table.component.html',
    styleUrls: ['./compliance-table.component.scss', './attestation-value-table.component.scss', './compliance-table-legend.scss']
})
export class ComplianceTableComponent implements OnInit, OnDestroy {
    /**
     * Структура данных, которая и будет рендериться в таблицу и по которой мы будем валидировать шаг.
     * @type {Array}
     */
    public data: WizardInterfaces.CompliationData[] = [];

    public objects: ModelsInterfaces.Object[] = [];

    public hasSpecialistsWithInvalidObjects = false;

    private subs: Subscription[] = [];

    constructor(
        public wizardFormEvents: WizardFormEventsService,
        private complianceService: ComplianceCalculateService,
        private objectsProvider: ObjectsProvider,
        private cd: ChangeDetectorRef,
        private wizardControl: WizardControlService,
        public complianceTableService: ComplianceCalculateService,
    ) {}

    ngOnInit() {
        this.subs.push(
            this.complianceService.complianceTableData$.subscribe(data => {
                this.data = data;
                this.cd.detectChanges();
            }),
            this.objectsProvider.data$.subscribe((objects) => {
                this.objects = objects.asRoot;
                this.cd.detectChanges();
            }),
            this.complianceTableService.specialists$.pipe(
                map((list: WizardSpecialist[]) => list.some((item) => {
                    return item.methods.some((method) => method.objects.some(o => !o.valid && o.inAttestation));
                }))
            ).subscribe((hasInvalid: boolean) => {
                this.hasSpecialistsWithInvalidObjects = hasInvalid;
                this.cd.detectChanges();
            })
        );
    }

    /**
     * Метод возвращает сообщение для тултипа,
     * в зависисомсти от того, заявлен объект полностью или нет и покрыт ли объект полностью
     * @param cell
     * @returns {any}
     */
    getMessageForCell(cell) {
        if (!cell) {
            return '';
        }

        let message = '';

        if (cell.full) {
            message += 'Заявлена полная область объекта; ';
        } else {
            message += 'Заявлена частичная область объекта; ';
        }

        if (cell.status === 1) {
            message += 'Полностью перекрыта удостоверениями специалистов ';
        } else if (cell.status === 0) {
            message += 'Частично перекрыта удостоверениями специалистов ';
        } else {
            message += 'Не перекрыта удостоверениями специалистов ';
        }

        return message;
    }

    goToAttestation() {
        this.wizardControl.activateStep(WizardEnums.Steps.attestation);
    }

    ngOnDestroy() {
        this.subs.forEach(s => s.unsubscribe());
    }
}
